import React, { useState } from "react";
// import JS files

// import others files

const EmptyList = (props) => {
  return (
    <>
      <div className="flex flex-col justify-center items-center">
        <props.icon sx={{ fontSize: "10rem", color: "#adb5bd" }} />
        <span className="text-myblack-100">{props.text}</span>
      </div>
    </>
  );
};

export default EmptyList;
